<div class="content-container"
     [ngClass]="{ 'content-container-margin': !contextbarService.isContextbarCollapsed, 'full-height': fullHeight, 'content-between': lastChangeInfo }">
  <ng-content></ng-content>
  <ng-container *ngTemplateOutlet="lastChangeInfo"></ng-container>
</div>
